require('./components/helper.js');
require('./components/navigation.js');
require('./components/inputs.js');
require('./components/contact-form.js');
require('./ajax.js');

